"use client";

import { useEffect, useRef } from "react";

const WebEngageAnalytics = () => {
  const hasRunRef = useRef(false);
  const initWebengage = () => {
    const licenseKey = process.env.NEXT_PUBLIC_WEBENGAGE_LICENSE_KEY;
    if (!window.webengage) {
      console.error("WebEngage is not defined");
      return;
    }
    if (!licenseKey) {
      console.error("WebEngage license key is missing");
      return;
    }
    // Initialize WebEngage with the license key from environment variables
    window.webengage.init(licenseKey);
    hasRunRef.current = true;
    console.log("WebEngage initialized");
  };

  useEffect(() => {
    if (!hasRunRef.current) {
      initWebengage();
    } else {
      console.log("Webengage already initialized");
    }
  }, []);

  return null;
};

export default WebEngageAnalytics;
